"use client";

import { Button, Tooltip } from "@mui/material";

import { usePasswordReset } from "@/context/passwordReset";
import { useEmailApi } from "@/context/passwordReset/email";

import StepButtonWrapper from "@/components/wrapper/stepButton";

export default function ForgotAnswerButton() {
  const { passwordResetUser } = usePasswordReset();
  const { setShowForgotAnswer } = useEmailApi();

  if (passwordResetUser?.email) return null;

  return (
    <StepButtonWrapper
      button={
        <Tooltip title="Click to return to answering your security question">
          <Button
            onClick={() => setShowForgotAnswer(false)}
            sx={{
              height: 48,
              padding: "1em 3em",
              width: {
                xs: "100%",
                md: "auto",
              },
            }}
          >
            Back
          </Button>
        </Tooltip>
      }
      containerJustifyContent="center"
      gridSize={{ xs: 12, md: 10 }}
      itemJustifyContent="center"
    />
  );
}
